<script>
	// From Lucide
	import { BookOpen } from 'lucide-svelte';

	export let iconClass = '';
</script>

<BookOpen class={iconClass} />
